import Form from 'cerebral-module-forms/Form'

export default function prepareCommonFields({ state }) {
  let {
    notSupportedEmailDomains,
    selectedLocale,
    locales,
    currentUser,
    sso
  } = state.get('client')

  const hideField = fieldName => {
    if (!currentUser) return false
    if (!currentUser.useSSO) return false
    return sso && sso.fields && sso.fields.indexOf(fieldName) !== -1
  }

  let emailValidations = ['isEmail']
  let emailErrorMessages = [{ key: 'bus-client.errors.email' }]
  if (notSupportedEmailDomains && notSupportedEmailDomains.length > 0) {
    notSupportedEmailDomains.forEach(domain => {
      emailValidations.push(`endsWith:"${domain}"`)
      emailErrorMessages.push({
        key: 'bus-client.errors.notSupportedEmailDomain',
        param: 'domain',
        value: domain
      })
    })
  }
  let commonData = {
    isRequired: true,
    client: true,
    type: 'text',
    value: ''
  }
  state.set(
    'client.registrating.current.common',
    Form({
      locale: {
        options: locales.map((locale, index) => {
          return {
            key: locale,
            value: locale,
            i18nKey: locale,
            index,
            selected: locale === selectedLocale
          }
        }),
        hidden: locales.length < 2 || hideField('locale'),
        localeAware: true, // will trigger another signal to set locale
        ...commonData,
        value: [
          {
            key: selectedLocale,
            value: selectedLocale,
            index: locales.indexOf(selectedLocale)
          }
        ],
        type: 'select'
      },
      email: {
        value: '',
        validations: emailValidations,
        errorMessages: emailErrorMessages,
        ...commonData,
        disabled: hideField('email')
      },
      username: {
        ...commonData,
        hidden: (currentUser && currentUser.useSSO) || false
      },
      validFrom: {
        value: '',
        isRequired: false,
        type: 'date',
        client: false,
        dependsOn: 'client.registrating.current.common.validTo'
      },
      validTo: {
        value: '',
        isRequired: false,
        type: 'date',
        client: false,
        dependsOn: 'client.registrating.current.common.validFrom',
        errorMessages: [{ key: 'bus-client.errors.validFromMustBeAfter' }],
        validations: ['dateCompare:"validFrom"']
      },
      firstname: {
        ...commonData,
        disabled: hideField('firstname')
      },
      lastname: {
        ...commonData,
        disabled: hideField('lastname')
      }
    })
  )
}



// WEBPACK FOOTER //
// ./src/modules/app/actions/prepareCommonFields.js